module.exports = __webpack_public_path__ + "img/1501390800.8bd3dda5.jpg";